import React from "react";

import DatagridUserActions from "../../actions/UserActions/DatagridUserActions";
import { SovosToolbarGroup, SovosBox, SovosIconButton, SovosToolbarActions } from "mosaic-react";
import { DefaultToolbar, StateInfoTab } from "colbi_web_ui/lib/components";
import { date } from "../../utils";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import theme from "mosaic-react/themes/index";
import { Refresh, Sync, Settings } from "mosaic-react-icons";

const RepositoryToolbar = ({ defaultToolbarProps, hideSeriesButton = false, toolbarProps }) => {
    const { location, i18n, fetch, reload, pushModal, params, modules } = useGlobalValue();
    const { projectId, section: paramsSection, locale } = params;
    const { rowsSelected } = toolbarProps;
    const section = location.pathname.split("/")?.pop();
    const path = section === "deleted_file_logs" ? "deleted_files" : section;

    const key = Object.keys(fetch.status).filter((key) => key.includes(section));
    const nowInMilliseconds = Date.now();
    const lastReadTime = new Date(fetch.status[key]?.lastReadTime || nowInMilliseconds)
        .toISOString()
        .replace("T", " ")
        .substring(0, 19)
        .split(" ")[1];
    const showSeriesButton = (modules) => {
        return modules.includes("delete_series") && !hideSeriesButton;
    };
    return (
        <SovosToolbarGroup sx={{ width: "100%" }}>
            <SovosToolbarGroup
                sx={{ flex: "1 1 auto", justifyContent: "flex-start", paddingRight: "10px" }}
            >
                <DatagridUserActions count={rowsSelected?.length} rowsSelectedIds={rowsSelected} />
                <SovosBox sx={{ display: "flex", flexDirection: "row" }}>
                    <StateInfoTab
                        sx={{
                            borderRight: `1px solid ${theme.palette.text.secondary};`,
                            paddingRight: "12px",
                            marginLeft: "12px",
                        }}
                        color={theme.palette.text.primary}
                        info=" "
                    >{i18n`${path}`}</StateInfoTab>
                    <StateInfoTab
                        sx={{ paddingLeft: "8px" }}
                        icon={<Sync />}
                        color={theme.palette.text.secondary}
                        info={lastReadTime}
                    >
                        {i18n`last_update`}: {date(nowInMilliseconds)},
                    </StateInfoTab>
                </SovosBox>
            </SovosToolbarGroup>
            <SovosToolbarGroup>
                <SovosToolbarActions>
                    <DefaultToolbar {...defaultToolbarProps} />
                    {showSeriesButton(modules) ? (
                        <SovosIconButton
                            children={<Settings />}
                            onClick={() =>
                                pushModal({
                                    title: i18n`Series Configuration`,
                                    args: {
                                        projectId,
                                        section: paramsSection,
                                        locale,
                                    },
                                    view: "SeriesForm",
                                })
                                    .then(() => reload && reload())
                                    .catch(() => null)
                            }
                            tooltipText={i18n`Series Configuration`}
                        />
                    ) : null}
                    <SovosIconButton
                        tooltipText={i18n`Reload`}
                        position="end"
                        onClick={() => {
                            reload && reload();
                        }}
                        children={<Refresh />}
                    />
                </SovosToolbarActions>
            </SovosToolbarGroup>
        </SovosToolbarGroup>
    );
};

export default RepositoryToolbar;
